/**
 * @generated SignedSource<<dfcbf655765cba1d13b7e2b61894deb2>>
 * @relayHash 02b4da2fe4ee05a81bed9c18800657ae
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 02b4da2fe4ee05a81bed9c18800657ae

import { ConcreteRequest } from 'relay-runtime';
export type de_BetterDocRecommendationState = "ADMISSION_FAILED" | "ADMITTED" | "ADMITTING" | "MEDIC_CONFIRMED" | "MEDIC_SELECTED" | "NO_SERVICE" | "PENDING" | "RECOMMENDED" | "REJECTED" | "RESEARCHING" | "RESEARCH_FAILED" | "SERVICE_TRIAGE_FAILED" | "TRIAGING";
export type de_BetterDocRecommendationType = "SECOND_OPINION" | "STANDARD";
export type de_BetterDocRemoteRequestStatus = "INVALID_RECOMMENDATION_ID" | "NOT_FOUND" | "RECEIVED" | "REQUEST_FAILED" | "UNEXPECTED_RESPONSE";
export type betterDocRemoteRecommendationQuery$variables = {
  recommendationId: string;
};
export type betterDocRemoteRecommendationQuery$data = {
  readonly de_betterDocRemoteRecommendation: {
    readonly errorReason: string | null;
    readonly exchangeId: number | null;
    readonly httpStatusCode: number | null;
    readonly recommendation: {
      readonly caseId: string | null;
      readonly insertedAt: string | null;
      readonly localSessionId: number | null;
      readonly medics: ReadonlyArray<{
        readonly gender: string | null;
        readonly glnNumber: string | null;
        readonly medhubId: number | null;
        readonly name: string | null;
        readonly selectionId: number | null;
        readonly selectionType: string | null;
        readonly travelTimeCar: number | null;
        readonly workplace: {
          readonly address: string | null;
          readonly ancestorName: string | null;
          readonly city: string | null;
          readonly countryCode: string | null;
          readonly name: string | null;
          readonly postalCode: string | null;
        } | null;
        readonly zsrNumber: string | null;
      }>;
      readonly partnerPatientId: string | null;
      readonly partnerSessionId: string | null;
      readonly reason: string | null;
      readonly recommendationId: string | null;
      readonly recommendationType: de_BetterDocRecommendationType | null;
      readonly secondOpinionVisitConfirmedAt: string | null;
      readonly secondOpinionVisitConfirmedByPatientAt: string | null;
      readonly selectionId: number | null;
      readonly selectionType: string | null;
      readonly state: de_BetterDocRecommendationState | null;
      readonly timeFrameEndingAt: string | null;
      readonly timeFrameStartingAt: string | null;
      readonly updatedAt: string | null;
    } | null;
    readonly status: de_BetterDocRemoteRequestStatus;
  };
};
export type betterDocRemoteRecommendationQuery = {
  response: betterDocRemoteRecommendationQuery$data;
  variables: betterDocRemoteRecommendationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "recommendationId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "selectionType",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "selectionId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "recommendationId",
        "variableName": "recommendationId"
      }
    ],
    "concreteType": "de_BetterDocRemoteRecommendationResult",
    "kind": "LinkedField",
    "name": "de_betterDocRemoteRecommendation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "httpStatusCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorReason",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "exchangeId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "de_BetterDocRemoteRecommendation",
        "kind": "LinkedField",
        "name": "recommendation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recommendationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "caseId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reason",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeFrameStartingAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeFrameEndingAt",
            "storageKey": null
          },
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recommendationType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "secondOpinionVisitConfirmedByPatientAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "secondOpinionVisitConfirmedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "insertedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "partnerPatientId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "partnerSessionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "localSessionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "de_BetterDocRemoteMedic",
            "kind": "LinkedField",
            "name": "medics",
            "plural": true,
            "selections": [
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "medhubId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gender",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "glnNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "zsrNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "travelTimeCar",
                "storageKey": null
              },
              (v1/*:: as any*/),
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "de_BetterDocRemoteWorkplace",
                "kind": "LinkedField",
                "name": "workplace",
                "plural": false,
                "selections": [
                  (v3/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ancestorName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "address",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "postalCode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "city",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "countryCode",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "betterDocRemoteRecommendationQuery",
    "selections": (v4/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "betterDocRemoteRecommendationQuery",
    "selections": (v4/*:: as any*/)
  },
  "params": {
    "id": "02b4da2fe4ee05a81bed9c18800657ae",
    "metadata": {},
    "name": "betterDocRemoteRecommendationQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2293d7437d58371a364c9539e440442d";

export default node;
